import { db } from "config/firebaseConfig";
import { useAuth } from "context/AuthContext";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { BsBell } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

const NotificationBell = () => {
  const { user } = useAuth();
  const [alerts, setAlerts] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    const q = query(
      collection(db, `users/${user.email}/alerts`),
      where("viewed", "==", false)
    );
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const notifications = [];
      querySnapshot.forEach((doc) => {
        notifications.push(doc.data());
      });
      setAlerts(notifications);
    });

    return () => {
      unsubscribe();
    };
  }, [user.email]);

  const handleNotifications = () => {
    navigate("notifications", { state: { alerts: alerts } });
  };
  return (
    <div className="relative cursor-pointer" onClick={handleNotifications}>
      <BsBell className="w-5 h-5" />
      {alerts && alerts.length > 0 && (
        <div className=" w-4 h-4 bg-red-500 rounded-full absolute flex items-center justify-center text-xs text-center font-bold -top-2 -right-1">
          <span>{alerts.length}</span>
        </div>
      )}
    </div>
  );
};

export default NotificationBell;
